module.exports = "/static/assets/4fc11c4215ee1b7b714ebeedbdd24392.png";